<template>
  <div>
    <my-header
      :page_name="$t('navigation.headerTitles.upgrades')"
      show_usermenu
    ></my-header>
    <reference-grid
      :gridData="getUpgradesTable"
      :columns="columnDefs"
      gridType="upgrades"
    ></reference-grid>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import ReferenceGrid from "../../components/reference/ReferenceGrid";
import i18n from "@/locales";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      columnDefs: [],
    };
  },
  created() {
    this.$store.commit("setLoading", true);
    this.columnDefs = [
      {
        headerName: i18n.t("tableHeaders.upgrades.idVersion"),
        field: "idVersion",
        comparator: (value1, value2) => parseInt(value1) - parseInt(value2),
        cellClass: "center-column",
        width: 80,
      },
      {
        headerName: i18n.t("tableHeaders.upgrades.datecurr"),
        field: "datecurr",
      },
    ];
    this.$store.dispatch("getUpgradesTable").catch(() => {
      this.$store.commit("setLoading", false);
    });
  },
  computed: {
    ...mapGetters(["getUpgradesTable"]),
  },
  components: {
    myHeader: Header,
    ReferenceGrid,
  },
};
</script>

